export default "__VITE_ASSET__df451a33__"